import { Divider, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const PREFIX = "ShowHideButton";

const classes = {
  text: `${PREFIX}-text`,
  button: `${PREFIX}-button`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.text}`]: {
    fontSize: "1rem",
    fontWeight: "bold",
    lineHeight: "1rem",
    margin: 0,
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },

  [`& .${classes.button}`]: {
    "float": "right",
    "marginTop": ".5rem",
    "marginBottom": ".5rem",
    "border": "1px solid #ffffff",
    "&:hover": {
      "backgroundColor": theme.palette.secondary.main,
      "border": "1px solid #ced6e3",
      "&:active": {
        backgroundColor: theme.palette.primary.main,
        color: "white",
      },
    },
  },
}));

interface Props {
  title: React.ReactNode;
  body: React.ReactElement;
  id?: string;
  missingCerts?: boolean;
}

export default function ShowHideButton({
  title,
  body,
  id,
  missingCerts,
}: Props) {
  return missingCerts ? (
    <StyledGrid container style={{ marginBottom: "1rem" }}>
      <Grid size={12}>
        <Typography
          variant="h3"
          sx={(theme) => ({
            fontSize: "1rem",
            fontWeight: "bold",
            lineHeight: "1rem",
            margin: 0,
            paddingTop: "1rem",
            paddingBottom: "1rem",
          })}
          id={id || "search-pill-title"}
        >
          {title}
        </Typography>
        <Divider style={{ marginBottom: "1rem" }} />
        {body}
      </Grid>
    </StyledGrid>
  ) : (
    <Grid container style={{ marginBottom: "1rem" }}>
      <Grid size={10}>
        <Typography
          variant="h3"
          sx={(theme) => ({
            fontSize: "1rem",
            fontWeight: "bold",
            lineHeight: "1rem",
            margin: 0,
            paddingTop: "1rem",
            paddingBottom: "1rem",
          })}
          id={id || "search-pill-title"}
        >
          {title}
        </Typography>
      </Grid>
      <Grid size={2}></Grid>
      <Grid size={12}>{body}</Grid>
    </Grid>
  );
}
